export default __webpack_public_path__ + "static/media/ng.a76a7b68.svg";